import React from "react";
import "../../InvoicingIATA.css";
import NoDataPlaceholder from "../../../../../components/element/NoDataPlaceholder";
import Loader from "../../../../../components/element/Loader";
import ErrorPopup from "../../../../../components/element/ErrorPopup";
import {
  formatToTwoDecimal,
  handleEmptyValue,
} from "../../../../../utils/utils";
import { DATE_FORMAT } from "../../../../../utils/constants";
import dayjs from "dayjs";
import { Button } from "@mui/material";

const ViewIATAInvoicingTable = ({
  invoicingData,
  isLoading,
  error,
  selectedIATAInvoicing,
  setSelectedIATAInvoicing,
  onClickView,
}) => {
  if (error) {
    if (error.status === 404) {
      return <NoDataPlaceholder />;
    } else {
      return <ErrorPopup children={error.message}></ErrorPopup>;
    }
  }

  if (isLoading) {
    return <Loader />;
  }

  if (invoicingData && invoicingData.length === 0) {
    return <NoDataPlaceholder />;
  }

  const handleSelectInvoice = (e, invoice) => {
    const updatedSelection = e.target.checked
      ? [...selectedIATAInvoicing, invoice]
      : selectedIATAInvoicing.filter((item) => item.id !== invoice.id);

    setSelectedIATAInvoicing(updatedSelection);
  };

  return (
    <div className="invoicing-IATA-table-parent-container">
      <div className="invoicing-IATA-table-container">
        <table className="invoicing-IATA-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Client Account Number</th>
              <th>Account Code</th>
              <th>Billing Document</th>
              <th>Client Invoice Reference</th>
              <th>Billing Date</th>
              <th>Payment Method</th>
              <th>IATA Airline Code</th>
              <th>E&F Airline Code</th>
              <th>Airline Name</th>
              <th>Data Currency</th>
              <th>Data Currency Amount</th>
              <th>Location Code</th>
              <th>Exchange Rate</th>
              <th>Billing Amount BT</th>
              <th>Tax Amt</th>
              <th>Billing Amount AT</th>
              <th>Charge Description</th>
              <th>Billing Doc Type</th>
              <th>Material</th>
              <th>Customer</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {invoicingData?.map((item, index) => (
              <tr key={index}>
                <td>
                  {
                    <div className="invoicing-IATA-table-checkbox-container">
                      <input
                        type="checkbox"
                        checked={selectedIATAInvoicing?.some(
                          (invoice) => invoice?.id === item.id
                        )}
                        onChange={(e) => handleSelectInvoice(e, item)}
                      />
                      <div>{index + 1}</div>
                    </div>
                  }
                </td>
                <td>{handleEmptyValue(item?.clientAccountNumber)}</td>
                <td>{handleEmptyValue(item?.accountCode)}</td>
                <td>{handleEmptyValue(item?.billingDocument)}</td>
                <td>{handleEmptyValue(item?.clientInvoiceReference)}</td>
                <td>{dayjs(item?.billingDate).format(DATE_FORMAT)}</td>
                <td>{handleEmptyValue(item?.paymentMethod)}</td>
                <td>{handleEmptyValue(item?.iataAirlineCode)}</td>
                <td>{handleEmptyValue(item?.efAirlineCode)}</td>
                <td>{handleEmptyValue(item?.airlineName)}</td>
                <td>{handleEmptyValue(item?.dataCurrency)}</td>
                <td>{formatToTwoDecimal(item?.dataCurrencyAmountLoan)}</td>
                <td>{handleEmptyValue(item?.locationCode)}</td>
                <td>{handleEmptyValue(item?.exchangeRate)}</td>
                <td>
                  {formatToTwoDecimal(
                    item?.billingAmountBeforeTaxLoan +
                      item?.billingAmountBeforeTaxPersonal
                  )}
                </td>
                <td>
                  {formatToTwoDecimal(
                    item?.taxAmountLoan + item?.taxAmountPersonal
                  )}
                </td>
                <td>
                  {formatToTwoDecimal(
                    item?.billingAmountAfterTaxLoan +
                      item?.billingAmountAfterTaxPersonal
                  )}
                </td>
                <td>{handleEmptyValue(item?.chargeDescriptionLoan)}</td>
                <td>{handleEmptyValue(item?.billingDocumentType)}</td>
                <td>{handleEmptyValue(item?.materialLoan)}</td>
                <td>{handleEmptyValue(item?.customer)}</td>
                <td>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={onClickView}
                  >
                    View
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ViewIATAInvoicingTable;
